import React, { useState, useEffect } from 'react';
import api from '../api';
import Layout from '../components/Layout';

export default function Dashboard() {
  const [stats, setStats] = useState({ totalMembers: 0, pendingApproval: 0, totalEvents: 0, ongoingEvents: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      api.get('/member-auth/admin/all'),
      api.get('/touring-events/'),
    ])
      .then(([membersRes, eventsRes]) => {
        const members = membersRes.data;
        const events = eventsRes.data;
        setStats({
          totalMembers: members.length,
          pendingApproval: members.filter((m) => !m.approved).length,
          totalEvents: events.length,
          ongoingEvents: events.filter((e) => e.status === 'ongoing').length,
        });
      })
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  }, []);

  const cardStyle = {
    background: '#1C2128', border: '1px solid #262b33', padding: 24,
    clipPath: 'polygon(0 0, 100% 0, 100% 90%, 90% 100%, 0 100%)',
  };

  return (
    <Layout>
      <h1 style={{ fontSize: 28, fontWeight: 900, fontStyle: 'italic', marginBottom: 24 }}>Dashboard</h1>

      {loading ? (
        <p style={{ color: '#8B92A0' }}>Memuat...</p>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 20 }}>
          <div style={cardStyle}>
            <p style={{ fontSize: 32, fontWeight: 900, color: '#2B6996' }}>{stats.totalMembers}</p>
            <p style={{ color: '#8B92A0', fontSize: 13, marginTop: 4 }}>Total Member</p>
          </div>
          <div style={cardStyle}>
            <p style={{ fontSize: 32, fontWeight: 900, color: '#D02127' }}>{stats.pendingApproval}</p>
            <p style={{ color: '#8B92A0', fontSize: 13, marginTop: 4 }}>Menunggu Approval</p>
          </div>
          <div style={cardStyle}>
            <p style={{ fontSize: 32, fontWeight: 900, color: '#2B6996' }}>{stats.totalEvents}</p>
            <p style={{ color: '#8B92A0', fontSize: 13, marginTop: 4 }}>Total Event Touring</p>
          </div>
          <div style={cardStyle}>
            <p style={{ fontSize: 32, fontWeight: 900, color: '#D02127' }}>{stats.ongoingEvents}</p>
            <p style={{ color: '#8B92A0', fontSize: 13, marginTop: 4 }}>Sedang Berlangsung</p>
          </div>
        </div>
      )}
    </Layout>
  );
}
